import * as React from "react";
import "./style_3.scss";
import PPLearnMoreBlock from "./PPLearnMoreBlock";

export default function ProductAccordionContentStyle3({ infoBlock }) {
  return (
    <div className={`accordion-content-block style_3`} key={infoBlock.title}>
      <img src={infoBlock.icon} alt="" />
      <h3>{infoBlock.title}</h3>
      {infoBlock.info && <h4>{infoBlock.info}</h4>}
      {infoBlock.care_symbols && (
        <div className={`care-symbols`}>
          {infoBlock.care_symbols.map((careIconName) => (
            <div className={`symbol-item`} key={careIconName}>
              <img
                src={`/static/images/eur_wash_symbol/${careIconName}.jpg`}
                alt=""
              />
            </div>
          ))}
        </div>
      )}

      {infoBlock.info_data && (
        <div className={`info-data`}>
          {infoBlock.info_data.map((infoItem) => (
            <div className={`info-data-item`} key={infoItem.title}>
              <h5>{infoItem.title}</h5>
              <p>{infoItem.info}</p>
              {infoItem.url && (
                <p>
                  <span>{infoItem.url.label}: </span>
                  <a target={infoItem.url.target} href={infoItem.url.href}>
                    {infoItem.url.name}
                  </a>
                </p>
              )}
            </div>
          ))}
        </div>
      )}

      {infoBlock.badge && (
        <div className={`badge-wrapper`}>
          <img src={infoBlock.badge} alt="" />
        </div>
      )}

      {infoBlock.learn_more && (
        <PPLearnMoreBlock
          learnMore={infoBlock.learn_more}
          learnMoreIcon={infoBlock.learn_more_icon}
        />
      )}
    </div>
  );
}
